import { useEffect, useState, memo } from 'react';
import PropTypes from 'prop-types';
import { SHOP_DELIVERY_TYPE } from '@shared/constants';

const WithPickupToggle = ({
  updateCartDeliveryType,
  isPickupSelected,
  children,
  hasCart,
  trackTogglePickupClicked,
  shopId,
  info,
  fetchMenuExtended,
  origin,
}) => {
  const [isPickup, setIsPickup] = useState(false);
  const [loading, setLoading] = useState(false);

  // Effect to check if is flow pickup by default
  useEffect(() => {
    setIsPickup(!!isPickupSelected);
  }, [isPickupSelected]);

  const handleOnToggleClick = async () => {
    const toggleStatus = !isPickup;
    setLoading(true);
    setIsPickup(toggleStatus);
    const success = await updateCartDeliveryType({
      deliveryType: toggleStatus
        ? SHOP_DELIVERY_TYPE.PICK_UP
        : SHOP_DELIVERY_TYPE.DELIVERY,
      mute: true,
    });
    trackTogglePickupClicked();
    setLoading(false);
    if (!success) {
      setIsPickup(!toggleStatus);
    } else {
      fetchMenuExtended({ shop: { id: shopId }, isPickup: toggleStatus });
    }
  };

  return children({
    onClick: handleOnToggleClick,
    loading: loading || !hasCart,
    info,
    isPickup,
    origin,
  });
};

WithPickupToggle.propTypes = {
  updateCartDeliveryType: PropTypes.func.isRequired,
  isPickupSelected: PropTypes.bool,
  hasCart: PropTypes.bool,
  trackTogglePickupClicked: PropTypes.func.isRequired,
  fetchMenuExtended: PropTypes.func.isRequired,
  shopId: PropTypes.number,
  info: PropTypes.shape({
    pickup: PropTypes.shape({
      time: PropTypes.shape({
        maxMinutes: PropTypes.number,
      }),
      distance: PropTypes.number,
      duration: PropTypes.number,
    }),
    delivery: PropTypes.shape({
      time: PropTypes.shape({
        minMinutes: PropTypes.number,
        maxMinutes: PropTypes.number,
      }),
      shipping: PropTypes.number,
      min: PropTypes.number,
    }),
  }).isRequired,
  origin: PropTypes.string,
};

export default memo(WithPickupToggle);
